import { createModel } from '@rematch/core';
import { selectors } from './selector';
import { RootState } from '../../store';
import { SnomedCategory } from '../../models/snomed-category';
import { getSnomedCategories } from '../../apis/emr-data';

interface ProcessData {
    byType: Dictionary<number[]>;
    byId: Dictionary<SnomedCategory>;
}

export interface State {
    byType: Dictionary<number[]>;
    byId: Dictionary<SnomedCategory>;
    loading: Dictionary<boolean>;
}

export const snomedCategories = createModel<State>({
    state: {
        byType: {},
        byId: {},
        loading: {}
    },
    reducers: {
        update: (
            state: State,
            data: Undefinable<SnomedCategory | SnomedCategory[]>,
            loadingKey?: string
        ): State => {
            const processedData = processData(data);
            return {
                ...state,
                byType: {
                    ...state.byType,
                    ...processedData.byType
                },
                byId: {
                    ...state.byId,
                    ...processedData.byId
                },
                ...loadingKey && {
                    loading: {
                        ...state.loading,
                        [loadingKey]: false
                    }
                }
            };
        },
        loading: (
            state: State,
            loadingKey: string,
            loading: boolean
        ): State => ({
            ...state,
            loading: {
                ...state.loading,
                [loadingKey]: loading
            }
        })
    },
    effects: () => ({
        async getSnomedCategoriesAsync(_: Undefinable<{}>, rootState: RootState) {
            if (!selectors.checkLoaded(rootState.snomedCategories)) {
                try {
                    const data = await getSnomedCategories();
                    this.update(data);
                } catch (e) {
                    window.console.log(e);
                }
            }
        }
    })
});

const processData = (data: Undefinable<MixType<SnomedCategory>>): ProcessData => {
    const byType = {} as Dictionary<number[]>;
    const byId = {} as Dictionary<SnomedCategory>;
    if (data) {
        if (Array.isArray(data)) {
            data.sort((a, b) => (a.recommendedAssessmentText || '') > (b.recommendedAssessmentText || '') ? 1 : -1);
            for (let i = 0; i < data.length; i++) {
                if (!byType[data[i].categoryTypeId]) {
                    byType[data[i].categoryTypeId] = [];
                }
                byType[data[i].categoryTypeId]!.push(data[i].code);
                byId[data[i].code] = data[i];
            }
        } else {
            byType[data.categoryTypeId] = [data.code];
            byId[data.code] = data;
        }
    }

    return {
        byType,
        byId
    };
};
